import React, { FC, useEffect } from 'react';
import {
  ButtonSize,
  SideSheet,
  SideSheetClose,
  SideSheetSize,
  Spinner,
  Box,
  SpinnerSize,
  Button,
  Text,
  Icon,
} from '@bechtel/gds';
import { SideSheetBodyStyled, SideSheetCloseContainer, SideSheetHeaderStyled } from './styled';
import { WeldDetailSidesheetProps } from './types';
import { WeldHeader } from '../weld-header';
import { WeldActions } from '../weld-actions';
import { WeldDetailItem } from '../weld-detail-item';
import { Trans } from '@lingui/macro';
import { Weld } from '@bechtel/types';
import { get } from 'lodash';
import { NetworkStatus } from '@apollo/client';
import { useWeldDetailById } from '~/hooks';

export const WeldDetailsSidesheet: FC<WeldDetailSidesheetProps> = ({ onClose, weldId }) => {
  const [getWeldDetailById, { loading, data, refetch, fetchMore, error, networkStatus }] = useWeldDetailById(true);
  const activityLimit = 10;

  useEffect(() => {
    if (weldId) {
      getWeldDetailById({
        variables: {
          ids: [weldId],
          paging: {
            cursor: '1',
            limit: activityLimit,
          },
        },
      });
    }
  }, [getWeldDetailById, weldId]);

  const weld: Weld = get(data, 'commoditiesByIds[0].weld');

  return (
    <SideSheet
      size={SideSheetSize.MEDIUM}
      visible
      style={{
        boxShadow: `0 1px 5px 0 rgba(0, 0, 0, 0.2), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 2px 2px 0 rgba(0, 0, 0, 0.14)`,
      }}
    >
      <SideSheetHeaderStyled title="">
        <SideSheetCloseContainer>
          <SideSheetClose onClick={onClose} size={ButtonSize.SMALL}></SideSheetClose>
        </SideSheetCloseContainer>
        {weld && <WeldHeader weld={weld} />}
      </SideSheetHeaderStyled>
      {weld && (
        <SideSheetBodyStyled data-testid="weld-details">
          <WeldActions weld={weld} />
          <WeldDetailItem weld={weld} loading={loading} fetchMore={fetchMore} />
        </SideSheetBodyStyled>
      )}

      {!loading && error && (
        <Box
          alignItems={{ sm: 'center' }}
          justifyContent={{ sm: 'center' }}
          flexGrow={{ sm: 1 }}
          flexDirection={{ sm: 'column' }}
          p={{ sm: '500' }}
        >
          <Box pb={{ sm: '500' }}>
            <Text>
              <Trans>There was a problem loading Welds Details. Please click the button below to try again.</Trans>
            </Text>
          </Box>
          <Button onClick={() => refetch()}>
            <Box mr={{ sm: '400' }}>
              <Icon icon="undo" />
            </Box>
            <Trans>Retry</Trans>
          </Button>
        </Box>
      )}
      {(networkStatus === NetworkStatus.refetch || loading) && (
        <Box
          p={{ sm: '500' }}
          alignItems={{ sm: 'center' }}
          justifyContent={{ sm: 'center' }}
          flexGrow={{ sm: 1 }}
          css={'height: 100%;'}
        >
          <Spinner size={SpinnerSize.LARGE} />
        </Box>
      )}
    </SideSheet>
  );
};
